import { useMemo } from 'react';

import { AssetCategory } from '@/entities/assets';
import { BeneficiaryGroupI18n } from '@/entities/beneficiary';
import { ContactTypeI18n, getContactFullName } from '@/entities/contact';
import { PidType } from '@/entities/personalIdentifiers';
import { PrivateDocumentCategory } from '@/entities/privateDocuments';
import { Country } from '@/shared/components';
import { getPersonFullName } from '@/shared/helpers/names';
import { CollectionName } from '@/shared/lib/sj-orm/types';
import { numbers } from '@/shared/utils/numbers';

import { isColDto } from '../../helpers';
import { UpdateCollectionsModalCollectionItem } from '../../types';

export const useFields = (_item: UpdateCollectionsModalCollectionItem) => {
  return useMemo(() => {
    const item = _item.data;
    if (isColDto(CollectionName.ASSETS, item)) {
      let price = '-';

      if (item.purchaseValue && 'value' in item.purchaseValue && 'from' in item.purchaseValue) {
        price = numbers.formatPrice(item.purchaseValue.value, item.purchaseValue.from);
      }

      return [
        { label: 'Title', value: item.nickName ?? item.nickname },
        { label: 'Category', value: <AssetCategory category={item.category} /> },
        { label: 'Country', value: <Country code={item.country} /> },
        { label: 'Value', value: price },
      ];
    }
    if (isColDto(CollectionName.PERSONAL_IDENTIFIERS_DOCUMENTS, item)) {
      return [
        { label: 'Title', value: item.name },
        { label: 'Type', value: <PidType type={item.personalIdentifierType} /> },
        { label: 'Associated', value: 'with Abbott John' },
        { label: 'Country', value: <Country code={item.country} /> },
      ];
    }
    if (isColDto(CollectionName.PRIVATE_DOCUMENTS, item)) {
      return [
        { label: 'Title', value: item.name },
        { label: 'Category', value: <PrivateDocumentCategory category={item.privateCategory} /> },
        { label: 'Country', value: <Country code={item.country} /> },
        { label: 'End date', value: 'with Abbott John' },
      ];
    }
    if (isColDto(CollectionName.BENEFICIARIES, item)) {
      return [
        { label: 'Nickname', value: getPersonFullName(item) },
        { label: 'Group', value: <BeneficiaryGroupI18n group={item.group} /> },
        { label: 'Country', value: <Country code={item.linkedCountryCode} /> },
      ];
    }

    if (isColDto(CollectionName.CONTACTS, item)) {
      return [
        { label: 'Nickname', value: getContactFullName(item) },
        { label: 'Category', value: <ContactTypeI18n type={item.type} /> },
        { label: 'Country', value: <Country code={item.selectedCountry} /> },
        // { label: 'Group affiliation', value: 'Family clan' },
      ];
    }

    return [];
  }, [_item]);
};
